<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">

    <app-transferperiod-stepper [activeAction]="activeAction"></app-transferperiod-stepper>
    @if(alert){
      <ngb-alert class="mt-5" [type]="alert.type">{{ alert.message }}</ngb-alert>
    }

    @if(!processing()){

      <!-- start header --> 
      @if(poolUser && assembleFormation){
        <div class="d-flex justify-content-between mt-3 mb-1">
          <!-- left -->      
            <button class="btn btn-outline-primary btn-sm ms-1"
              (click)="linkToTransfers(poolUser, assembleFormation, contentRemove)">
              <fa-icon [icon]=faChevronLeft></fa-icon>
              <fa-icon [icon]=faChevronLeft></fa-icon>
            </button>                
          
          <!-- center -->
          <div>
            @if(pool && calcFormation){
              <button class="btn btn-secondary" disabled>
                {{calcFormation.getName()}}
              </button>
            }
          </div>

          <!-- right -->    
          <button class="btn btn-outline-info mx-1"
            (click)="openActionsOverviewModal(poolUser)">
            <fa-icon [icon]=faInfoCircle></fa-icon>
          </button>
          
        </div> <!-- end header -->
      }

      @if(alert){
      <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
      }

      <div>      
        @if(pool && poolUser && assembleFormation && calcFormation && !selectedPlace){
          <!-- lines-->
          @for(line of calcFormation.getLines();track line.getNumber()) {
            <app-pool-formationline-substitutions [line]="line"
              [substitutions]="poolUser.getTransferPeriodActionList().substitutions"
              (substitute)="substitute(assembleFormation, $event)" (linkToPlayer)="linkToPlayer(pool, $event)"
              (remove)="remove(pool, assembleFormation, $event, false)">
            </app-pool-formationline-substitutions>
          }
        }
      </div>
    } @else {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
  </div>
</div>

@if(!processing() && pool){
<app-pool-navbar [pool]="pool" [poolUser]="poolUser"></app-pool-navbar>
}

<ng-template #contentRemove let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <span>wissels ongedaan maken</span>
    </h4>
    <button type="button" class="btn-close" aria-label="sluiten" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Je wissels worden ongedaan gemaakt wanneer je naar "transfer" gaat</p>
  </div>
  <div class="modal-footer d-flex justify-content-reverse border-top-0">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modal.close(poolUser)">
      ga naar "transfer"</button>
  </div>
</ng-template>